export default __webpack_public_path__ + "static/media/dumbbell.2011c89a.svg";